// extracted by mini-css-extract-plugin
export default {"CentrePattern":"centre-pattern_CentrePattern__1Idm-"};